import { i18n } from "@/i18n";

export default {
  path: "/matching",
  name: "MatchingLayoutView",
  redirect: { name: "MatchingCatalogList" },
  component: () => import(/* webpackChunkName: "matching" */ "@/views/Matching/MatchingLayoutView.vue"),
  meta: {
    breadcrumb: true,
    authRequired: true,
    title: i18n.global.t("page.matching_dashboard"),
  },
  children: [
    {
      path: "catalog",
      name: "MatchingCatalogList",
      component: () =>
        import(/* webpackChunkName: "matching" */ "@/views/Matching/Catalog/MatchingCatalogListView.vue"),
      meta: {
        title: i18n.global.tc("matching.catalog.title", 1),
        breadcrumb: true,
      },
    },
    {
      path: "groups",
      name: "MatchingGroupsList",
      component: () => import(/* webpackChunkName: "matching" */ "@/views/Matching/Groups/MatchingGroupsListView.vue"),
      meta: {
        title: i18n.global.tc("matching.groups.title", 1),
        breadcrumb: true,
      },
    },
    {
      // Espace candidat Placement : hideStaffMenu coupe le SideMenuComponent et le chargement du
      // menu/permissions staff dans MatchingLayoutView (ce parent les impose à tous ses enfants,
      // pas seulement à candidate) — un candidat n'a pas le menu catalogue/groupes de gestion.
      path: "candidate",
      name: "MatchingCandidateLayout",
      redirect: { name: "MatchingCandidateSheet" },
      meta: {
        authRequired: true,
        breadcrumb: true,
        hideStaffMenu: true,
        title: i18n.global.t("matching.candidateInformation.title"),
      },
      children: [
        {
          // `:tab?` reprend le motif de la fiche d'inscription (/registration/.../:tab) : l'onglet
          // actif vit dans l'URL, ce dont a besoin TabComponent (lecture de $route.params.tab).
          path: "sheet/:tab?",
          name: "MatchingCandidateSheet",
          component: () =>
            import(/* webpackChunkName: "placement" */ "@/views/Matching/Candidate/MatchingCandidateSheetView.vue"),
          meta: {
            authRequired: true,
            breadcrumb: true,
            hideStaffMenu: true,
            title: i18n.global.t("matching.candidateInformation.title"),
          },
        },
      ],
    },
    {
      path: "prospects",
      name: "MatchingProspectsList",
      component: () => import(/* webpackChunkName: "matching" */ "@/views/Matching/Prospects/ProspectsListView.vue"),
      meta: {
        title: i18n.global.tc("matching.prospects.title", 1),
        breadcrumb: true,
      },
    },
  ],
};
